import React from "react";
import { NavLink } from "react-router-dom";
import Imagen2 from "../../../images/dashboardAbogados/Imagen2.svg";
function IndexBoxTwo({ height, templatesCount = 0, title }) {
  return (
    <div className="inicio__box inicio__box2" style={{ height: height }}>
      <h4>{title}</h4>
      <div className="inicio__box-primera">
        <div className="plantillasN" style={{ marginTop: "12px" }}>
          <h6>Plantillas</h6>
          <p className="plantillasCount">{templatesCount}</p>
          <NavLink
            className="inicio__box-primera-button"
            to="/lawyers/templates/create"
          >
            <p>Crear Plantilla</p>
          </NavLink>
        </div>
        <div className="image2">
          <img src={Imagen2} alt="Imagen2" />
        </div>
      </div>
    </div>
  );
}

export default IndexBoxTwo;
